var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTennis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.2139 30.7862C67.1736 24.7459 59.1983 21.8183 51.2825 22.0087L63.5077 34.2286C71.5385 42.318 71.5238 55.3875 63.4562 63.4544C55.389 71.5216 42.3177 71.5401 34.2315 63.5017V63.5055L22.0084 51.2824C21.8217 59.1952 24.7477 67.1752 30.7863 73.2138C42.5015 84.929 61.5015 84.929 73.2145 73.2138C84.9286 61.4954 84.9286 42.5019 73.2141 30.7867L73.2139 30.7862Z",
    fill: "#592EE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4736 60.2393C40.5134 63.2644 44.5522 64.9231 48.8438 64.9198C53.132 64.9122 57.1693 63.2389 60.2011 60.2033C63.2367 57.171 64.9105 53.1346 64.9176 48.8438C64.9247 44.5538 63.2661 40.5129 60.2413 37.4736L60.0693 37.3016L45.4815 22.7117C40.0946 23.902 34.9751 26.5935 30.7856 30.7864C26.5999 34.9756 23.9044 40.0917 22.7146 45.4803L37.3109 60.0819L37.4736 60.2393Z",
    fill: "#592EE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennis);
export default __webpack_public_path__ + "static/media/Tennis.d84ae29f44e9e12278d4dfddda75769d.svg";
export { ForwardRef as ReactComponent };